<template>
<div :class="`ee-label ee-label--${size}`" :style="`width:${width ? `${width}px`: 'auto'}`">
  <a v-for="k in dataSource" @click="handleClick(k)" :class="{'is-active': isActive(k)}" href="javascript:;">{{text(k)}}<i class="text-icon icon-ok"></i></a>
  <span v-if="errorMsg" class="ee-label__error-msg">太多了</span>
</div>
</template>
<script>
  export default {
    compName: 'ee-label',
    props: {
      width: Number,
      size: {
        type: String,
        default: 'default'
      },
      dataSource: {
        type: Array,
        required: true,
        default: []
      },
      value: [String, Array],
      max: {
        type: Number,
        default: -1
      },
      min: {
        type: Number,
        default: -1
      }
    },
    methods: {
      handleClick (item) {
        item = item.value || item
        let index = -1
        for (let i = 0, len = this.current.length; i < len; i++) {
          if (this.current[i] === item) {
            index = i
            break
          }
        }
        if (index >= 0) {
          if (this.min > 0 && this.current.length <= this.min) {
            this.errorMsg = `最少选择${this.min}个`
            return
          }
          this.current.splice(index, 1)
        } else {
          if (this.max > 0 && this.current.length >= this.max) {
            this.errorMsg = `最多选择${this.max}个`
            return
          }
          this.current.push(item)
        }
        this.errorMsg = ''
        this.$emit('input', this.valueType === 'string' ? this.current.join() : [...this.current])
      },
      text (item) {
        return typeof item === 'object' ? item.text : item
      },
      isActive (item) {
        item = item.value || item
        return this.current.includes(item)
      }
    },
    data () {
      const valueType = Array.isArray(this.value) ? 'array' : 'string'
      const current = valueType === 'string' ? (this.value ? this.value.split(/\s*,\s*/) : []) : this.value
      return {
        errorMsg: '',
        current,
        valueType
      }
    },
    watch: {
      value () {
        this.current = this.valueType === 'string' ? (this.value ? this.value.split(/\s*,\s*/) : []) : this.value
      }
    }
  }
</script>
<style>
@import "../style/vars.css";
@component-namespace ee {
  @b label {
    @utils-clearfix;
    @e error-msg {
      float: left;
      color: #b43731;
    }
    a {
      position: relative;
      float: left;
      margin-right: 10px;
      border: 1px solid #eee;
      font-size: 12px;
      line-height: 1;
      .text-icon {
        display: none;
        position: absolute;
        width: 0;
        height: 0;
        top: 0;
        right: 0;
        border-style: solid;
        border-color: var(--main-color) var(--main-color) transparent transparent;
        font-family: easteat;
      }
      @when active {
        border-color: var(--main-color);
        .text-icon {
          display: inline;
          &:before {
            position: absolute;
            color: #fff;
          }
        }
      }
    }
    @m xlarge {
      a {
        margin: 0 20px 20px 0;
        height: 54px;
        padding: 15px 20px;
        font-size: 22px;
        &.is-active {
          .text-icon {
            border-width: 12px 20px;
            &:before {
              top: -12px;
              right: -20px;
              font-size: 16px;
            }
          }
        }
      }
      .ee-label__error-msg {
        line-height: 54px;
      }
    }
    @m large {
      a {
        margin: 0 20px 20px 0;
        height: 48px;
        padding: 14px 20px;
        font-size: 18px;
        &.is-active {
          .text-icon {
            border-width: 12px 20px;
            &:before {
              top: -12px;
              right: -20px;
              font-size: 16px;
            }
          }
        }
      }
      .ee-label__error-msg {
        line-height: 48px;
      }
    }
    @m middle {
      a {
        margin: 0 20px 20px 0;
        height: 42px;
        padding: 12px 20px;
        font-size: 16px;
        &.is-active {
          .text-icon {
            border-width: 10px 19px;
            &:before {
              top: -11px;
              right: -18px;
              font-size: 14px;
            }
          }
        }
      }
      .ee-label__error-msg {
        line-height: 42px;
      }
    }
    @m default {
      a {
        margin: 0 18px 18px 0;
        height: 36px;
        padding: 11px 20px;
        font-size: 14px;
        &.is-active {
          .text-icon {
            border-width: 9px 16px;
            &:before {
              top: -11px;
              right: -16px;
              font-size: 14px;
            }
          }
        }
      }
      .ee-label__error-msg {
        line-height: 36px;
      }
    }
    @m small {
      a {
        margin: 0 15px 15px 0;
        height: 30px;
        padding: 7px 15px;
        font-size: 14px;
        &.is-active {
          .text-icon {
            border-width: 9px 12px;
            &:before {
              top: -9px;
              right: -13px;
              font-size: 12px;
            }
          }
        }
      }
      .ee-label__error-msg {
        line-height: 30px;
      }
    }
    @m tiny {
      a {
        margin: 0 10px 10px 0;
        height: 24px;
        padding: 5px 15px;
        font-size: 12px;
        &.is-active {
          .text-icon {
            border-width: 7px 13px;
            &:before {
              top: -9px;
              right: -12px;
              font-size: 12px;
            }
          }
        }
      }
      .ee-label__error-msg {
        line-height: 24px;
      }
    }
    @m mini {
      a {
        margin: 0 10px 10px 0;
        height: 18px;
        padding: 2px 15px;
        font-size: 12px;
        &.is-active {
          .text-icon {
            border-width: 6px 10px;
            &:before {
              top: -9px;
              right: -12px;
              font-size: 12px;
            }
          }
        }
      }
      .ee-label__error-msg {
        line-height: 18px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/packages/label/Label.vue?212994f2